import { useEffect, useState } from 'react';
import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';
import { useApi, formatPrice } from '../../lib/api';

type Sale = {
  order_id: string;
  status: string;
  total_cents: number;
  fee_cents: number;
  quantity: number;
  created_at: number;
  tickets_transferred_at: number | null;
  section: string;
  row: string;
  seats_json: string;
  opponent: string;
  game_date: string;
  buyer_email: string;
};

export default function SellerSales() {
  const api = useApi();
  const [sales, setSales] = useState<Sale[]>([]);

  async function refresh() {
    const { orders } = await api<{ orders: Sale[] }>('/orders/sales');
    setSales(orders);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, []);

  async function markTransferred(id: string) {
    await api(`/orders/${id}/transferred`, { method: 'POST' });
    await refresh();
  }

  return (
    <section>
      <h2>My sales</h2>
      <SignedOut>
        <SignInButton mode="modal" />
      </SignedOut>
      <SignedIn>
        {sales.length === 0 && <p className="muted">No sales yet.</p>}
        <div className="grid cols-3">
          {sales.map((s) => {
            const seats = JSON.parse(s.seats_json) as string[];
            const payout = s.total_cents - s.fee_cents;
            return (
              <div key={s.order_id} className="card">
                <p>
                  <strong>{s.opponent}</strong> — {s.game_date}
                </p>
                <p className="muted">
                  Sec {s.section} Row {s.row} · Seats {seats.join(', ')}
                </p>
                <p>Buyer: {s.buyer_email}</p>
                <p className="price">
                  {formatPrice(s.total_cents)}{' '}
                  <span className="muted" style={{ fontWeight: 400 }}>
                    (payout {formatPrice(payout)})
                  </span>
                </p>
                <p>
                  <span className="badge">{s.status.replace(/_/g, ' ')}</span>
                </p>
                {s.status === 'paid_escrow' && (
                  <button onClick={() => markTransferred(s.order_id)}>
                    Mark tickets transferred
                  </button>
                )}
                {s.status === 'tickets_transferred' && (
                  <p className="muted">Awaiting buyer confirmation (auto-release at 48 h).</p>
                )}
              </div>
            );
          })}
        </div>
      </SignedIn>
    </section>
  );
}
